import { jsx as _jsx } from "react/jsx-runtime";
import { Backdrop, CircularProgress } from '@mui/material';
import { defineStyles, theme } from '../../theme';
const styles = defineStyles({
    loadingContainer: {
        color: theme.vars.palette.common.white,
        zIndex: 99999,
    },
});
const DefaultBackdrop = ({ isLoading }) => (_jsx(Backdrop, { sx: styles.loadingContainer, open: isLoading, children: _jsx(CircularProgress, { color: "inherit" }) }));
export default DefaultBackdrop;
//# sourceMappingURL=DefaultBackdrop.js.map